import { normalizeString } from "./normalizeString";

const validityObject = {
  spots: ["code", "name", "agency_id", "user_tag", "district"],
  agency: ["name", "code", "territories_id", "district", "ma_wallet"],
  territories: ["name", "areas_id", "district"],
  areas: ["name", "regions_id", "district"],
  regions: ["name", "division", "clusters_id"],
  clusters: ["name", "division"],
};

const checkValidity = (object, zone) => {
  var errorMessages = [];
  validityObject[zone].forEach((e) => {
    if (!object[e] || object[e] === "")
      errorMessages.push(`${normalizeString(e)}`);
  });

  return errorMessages;
};

export default checkValidity;
